document.addEventListener('DOMContentLoaded', function() {
  const cardsContainer = document.querySelector('.promotion-row__grid');
  const buttons = document.querySelectorAll('.custom-gym-nav-btn a');

  function updateActiveLinkOnScroll() {
    buttons.forEach(function(button) {
      const targetId = button.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId + '-qode');

      if (targetElement && isElementInViewport(targetElement)) {
        buttons.forEach(a => a.classList.remove('active'));
        button.classList.add('active');
      }
    });
  }

  function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  const container = el.closest('.promotion-row__grid'); 

  return (
    rect.left >= container.getBoundingClientRect().left &&
    rect.right <= container.getBoundingClientRect().right
  );
  }

  cardsContainer.addEventListener('scroll', updateActiveLinkOnScroll);

  buttons.forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent default anchor click behavior

      buttons.forEach(a => a.classList.remove('active'));
      this.classList.add('active');

      const targetId = this.getAttribute('href').substring(1);
      scrollToElement(targetId);
    });
  });
    
  function scrollToElement(targetId) {
    const targetElement = document.getElementById(targetId + '-qode');
    if (targetElement && cardsContainer) {
      const scrollLeft = targetElement.offsetLeft - cardsContainer.offsetLeft;
      cardsContainer.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  }
  updateActiveLinkOnScroll();
  });